<script>
import fundraiserPublicFetchMixin from '@/mixins/fundraiserPublicFetchMixin.js'
import TwCard from '@/components/generic/tw-card.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwContainerFullWidth from '../../../components/generic/tw-container-full-width.vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import RegisterUserAccount from '@/components/user/register-user-account.vue'
import LoginForm from '@/components/auth/login-form.vue'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwAmount from '@/components/generic/forms/tw-amount.vue'
import TwWysiwyg from '@/components/generic/forms/tw-wysiwyg.vue'
import TwDate from '@/components/generic/forms/tw-date.vue'
import { useAuthStore } from '@/stores/auth.js'
import { useFundraiserStore } from '@/stores/fundraiser.js'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import TwSelect from '@/components/generic/forms/tw-select.vue'
import TeamEditModal from '@/components/teams/team-edit-modal.vue'
import UserAvatarEditor from '@/components/user/user-avatar-editor.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import TwRadio from '../../../components/generic/forms/tw-radio.vue'

export default {
  name: 'FundraiserJoinPage',
  components: { TwRadio, TwTransitionContainer, TwLoadingSpinner, UserAvatarEditor, TeamEditModal, TwSelect, TwValidationErrors, TwDate, TwWysiwyg, TwAmount, TwInput, LoginForm, RegisterUserAccount, TwModal, TwContainerFullWidth, TwButton, TwCard },
  mixins:[fundraiserPublicFetchMixin, loggedInUserMixin],
  props: {
    fundraiserInvite: {
      type: Object,
      default: null
    },
    teamId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      LoadingJoiningCause: false,
      ValidationErrorMessage: null,
      CustomFields: {},
      JoinTeamEnabled: 'No',
      FundraiserPageData: {
        title: null,
        short_description: null,
        long_description: null,
        goal: null,
        deadline: null
      },
      TeamCreated: null,
      YoutubeVideoUrl: null,
      ShowYoutubeVideoPreview: false,
      PhotoUploaded: null
    }
  },
  computed: {
    youtubeVideoSlug() {
      if(this.YoutubeVideoUrl) {
        return this.YoutubeVideoUrl.split('v=')[1]
      }
      return null
    },
    teamsAvailable() {
      if(this.fundraiser.teams) {
        const teams = this.fundraiser.teams.map(team => ({ id: team.id, name: team.name }))
        if (this.TeamCreated) {
          teams.push({ id: this.TeamCreated.id, name: this.TeamCreated.name })
        }
        return teams
      }
      return null
    },
    canBeCropped() {
      return !!(this.PhotoUploaded && ['jpg','jpeg','png','webp'].indexOf(this.PhotoUploaded.extension) > -1)
    },
    loggedInUser() {
      return useAuthStore().user
    },
    customFieldsRequired() {
      if(this.fundraiser.custom_fields) {
        return this.fundraiser.custom_fields.filter(item => item.require_on_join)
      }
      return []
    },
    fundraiserCurrency() {
      return this.fundraiser?.currency_metadata?.code || this.fundraiser?.currency || this.fundraiser?.settings?.currency
    },
    fundraiserPageGoalFormatted() {
      return this.$filters.formatCurrency(this.FundraiserPageData.goal, this.fundraiserCurrency)
    }
  },
  async mounted() {
    await this.fetchFundraiser()
    this.FundraiserPageData.title = this.fundraiser.title
    this.FundraiserPageData.short_description = this.fundraiser.short_description
    this.FundraiserPageData.long_description = this.fundraiser.settings.default_long_desc? this.fundraiser.settings.default_long_desc : null
    this.FundraiserPageData.goal = this.fundraiser.settings.default_goal ? this.fundraiser.settings.default_goal: this.fundraiser.goal
    this.FundraiserPageData.deadline = this.fundraiser.settings.default_deadline ? this.fundraiser.settings.default_deadline: this.fundraiser.deadline


    if(this.fundraiserInvite && this.fundraiserInvite.existing_user && this.fundraiserInvite.existing_user.autologin_token) {
      await useAuthStore().loginViaToken(this.fundraiserInvite.existing_user.autologin_token)
    }
    else if(!this.loggedInUser) {
      // await this.openRegisterUserModal()
    }

    if(this.teamId) {
      this.FundraiserPageData.belongs_to_team_id = this.teamId
    }
  },
  methods: {
    async openRegisterUserModal() {
      await this.$refs.userRegisterAccountModal.open()
      if(this.fundraiserInvite && this.$refs.registerUserAccount) {
        this.$refs.registerUserAccount.setEmail(this.fundraiserInvite.email)
      }
    },
    cropped(item){
      this.PhotoUploaded = item
    },
    async userRegistered(user) {
      await this.$refs.userRegisterAccountModal.close()
      await useAuthStore().login(user, true)
      this.FundraiserPageData.title = this.fundraiser.title + ' by ' + user.name
    },
    userLoggedIn() {
      this.$refs.userLoginModal.close()
      this.FundraiserPageData.title = this.fundraiser.title + ' by ' + useAuthStore().user.name
    },
    createdTeam(team) {
      this.TeamCreated = team
      this.FundraiserPageData.belongs_to_team_id = team.id
    },
    async joinCause() {
      try {
        if(confirm('Are you sure you want to join this cause?')) {
          this.ValidationErrorMessage = null
          this.LoadingJoiningCause = true
          const fundraiserPage = await useFundraiserStore().fundraiserJoin(this.fundraiser.id, {
            ...(this.CustomFields && { custom_fields: this.CustomFields }),
            ...(this.fundraiserInvite && { fundraiser_invite_id: this.fundraiserInvite.id }),
            ...this.FundraiserPageData,
            ...(this.PhotoUploaded && { photo_upload_id: this.PhotoUploaded.id }),
            ...(this.YoutubeVideoUrl && { youtube_video_url: this.YoutubeVideoUrl })
          })
          this.LoadingJoiningCause = false
          this.$router.push({ name: 'FundraiserPagePublicPage', params: { fundraiserPageId: fundraiserPage.id, slug: fundraiserPage.slug } })
          this.$notify('You have successfully joined this cause')
        }
      } catch (e) {
        console.error(e)
        this.LoadingJoiningCause = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        this.$notify('An error occurred while joining this cause', 'error')
        throw e
      }
    }
  }
}
</script>

<template>
  <tw-container-full-width class="flex items-center py-8 md:py-10 max-w-[836px]">
    <div v-if="fundraiser && fundraiser.settings && fundraiser.settings.lock_joining" class="flex flex-col gap-1">
      <h2>
        {{ fundraiser.title }}
      </h2>
      <div>
        You cannot join this campaign at this time.
      </div>
    </div>
    <div v-else class="flex flex-col gap-6">
      <!-- <h2 v-if="fundraiserInvite" class="mt-10 mb-5 text-center">
        Hello {{ loggedInUser? loggedInUser.name: fundraiserInvite.email }}
      </h2> -->
      <div class="flex flex-col gap-1">
        <h2 v-if="fundraiser">
          Join this Cause
        </h2>
        <h4 v-if="fundraiser">
          {{ fundraiserInvite? 'You have been invited to join the fundraiser ':'Create a personal fundraising page for' }}
          <router-link class="underline" target="_blank" :to="{ name: 'FundraiserPublicPage', params: { fundraiserId: fundraiser.id, slug: fundraiser.slug } }">
            {{ fundraiser.title }}
          </router-link>
        </h4>
      </div>
      <tw-transition-container>
        <div v-if="!Loading && fundraiser">
          <tw-card v-if="fundraiserInvite && fundraiserInvite.message" class="bg-amber-50">
            <div v-html="fundraiserInvite.message" />
          </tw-card>
          <tw-card class="bg-white flex flex-col gap-8" size="lg">
            <div v-if="fundraiser.settings && fundraiser.settings.signup_instructions">
              <div class="flex flex-col gap-3" v-html="fundraiser.settings.signup_instructions" />
            </div>
            <div v-if="loggedInUser" class="border-t pt-8">
              <h2 class="">
                Create Fundraising Page
              </h2>
              <h6 class="text-gray-500">
                Logged in as {{ loggedInUser.name }}
              </h6>
            </div>
            <div v-else class="bg-gray-50 rounded-xl p-6">
              <h3 class="mb-1">
                Create a GroupRev account or login to continue
              </h3>
              <p>GroupRev is the #1 free crowd fundraising platform for groups & teams</p>
              <div class="flex flex-col sm:flex-row gap-3 mt-6">
                <tw-button variant="amber" size="lg" class="w-full sm:w-auto" @click="openRegisterUserModal">
                  Sign Up
                </tw-button>
                <tw-button v-if="!fundraiserInvite" size="lg" variant="outline" class="w-full sm:w-auto" @click="$refs.userLoginModal.open()">
                  Login
                </tw-button>
              </div>
            </div>
            <div v-if="loggedInUser" class="form-spacing-lg">
              <div v-if="fundraiser.settings.lock_title && fundraiser.settings.lock_title === true" class="form-label">
                Title: {{ FundraiserPageData.title }}
              </div>
              <tw-input v-else v-model="FundraiserPageData.title" label="Title of your fundraiser*" />
              <tw-radio v-if="fundraiser.settings.enable_teams" v-model="JoinTeamEnabled" :options="['No','Yes']" label="Join a team?" />


              <div v-if="loggedInUser && fundraiser.settings.enable_teams && JoinTeamEnabled === 'Yes'">
                <h5 class="mb-2">
                  Join a Team
                </h5>
                <tw-card v-if="fundraiser.settings.teams_message" class="bg-gray-50 mb-3">
                  <div v-html="fundraiser.settings.teams_message" />
                </tw-card>

                <div class="flex flex-col sm:flex-row gap-2">
                  <tw-select v-if="teamsAvailable && teamsAvailable.length > 0" v-model="FundraiserPageData.belongs_to_team_id" :options="teamsAvailable" value-key="id" label-key="name" class="flex-1" />
                  <div v-if="teamsAvailable && teamsAvailable.length === 0">
                    No teams created yet. <span v-if="fundraiser.settings.enable_create_teams"> Create one below</span><span v-else> Contact the campaign manager to create teams for you to join </span>
                  </div>
                  <div v-if="fundraiser.settings.enable_create_teams" class="sm:mt-3 sm:mx-1 text-sm font-medium">
                    or
                  </div>
                  <tw-button v-if="fundraiser.settings.enable_create_teams" size="sm" variant="outline" icon="plus" @click="$refs.createTeamModal.open()">
                    Create New Team
                  </tw-button>
                </div>
                <team-edit-modal ref="createTeamModal" :fundraiser="fundraiser" @created="createdTeam" />
              </div>

              <div class="grid lg:grid-cols-2 gap-8 lg:gap-6">
                <div v-if="fundraiser.settings.lock_goal" class="form-label">
                  Goal: {{ fundraiserPageGoalFormatted }}
                </div>
                <tw-amount v-else v-model="FundraiserPageData.goal" :disabled="fundraiser.settings && fundraiser.settings.lock_goal" :currency="fundraiserCurrency" label="Fundraising Goal*" />
                <div v-if="fundraiser.settings.lock_deadline === true" class="form-label">
                  Deadline: {{ $filters.formatDateOnly(FundraiserPageData.deadline) }}
                </div>
                <tw-date v-else v-model="FundraiserPageData.deadline" :disabled="fundraiser.settings && fundraiser.settings.lock_deadline" label="Fundraising Deadline*" />
              </div>
              <tw-wysiwyg v-model="FundraiserPageData.long_description" :disabled="fundraiser.settings && fundraiser.settings.lock_long_desc" label="Description" small-label="Share your story, what you are doing and why people should contribute to your project and how you will use the money raised." />
            </div>
            <tw-validation-errors :validation-result-error="ValidationErrorMessage" />

            <div v-if="loggedInUser" class="form-spacing-lg">
              <div>
                <user-avatar-editor v-if="loggedInUser" />
              </div>
              <div>
                <tw-input v-model="YoutubeVideoUrl" label="Youtube Video" small-label="Include a video for your cause. This will be displayed before the gallery images." placeholder="Youtube URL" @blur="ShowYoutubeVideoPreview = true" />
                <div v-if="ShowYoutubeVideoPreview && youtubeVideoSlug" class="mt-4">
                  <iframe class="embed-responsive-item w-full h-80" :src="`https://www.youtube.com/embed/${youtubeVideoSlug}`" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
                </div>
              </div>
              <!--
              TODO: Should this be replaced with image gallery?
              <div class="">
                <div>
                  <div class="form-label mb-3">
                    Upload an Image
                  </div>
                  <tw-upload-field v-model="PhotoUploaded" images-only />
                </div>
                <div v-if="PhotoUploaded">
                  <div class="mt-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                    <div class="overflow-hidden rounded-lg bg-white shadow">
                      <div :class="['p-3 flex justify-center', {'h-40': !readonly}]">
                        <a :href="PhotoUploaded.url" target="_blank" class="text-blue-500 underline">
                          <img :src="PhotoUploaded.url" class="object-cover object-center max-h-full">
                        </a>
                      </div>
                      <div class="px-3 pb-3 flex gap-2">
                        <tw-button v-if="canBeCropped" variant="light" size="sm" class="grow" block @click="$refs.imageCropModal.open()">
                          <icon icon="scissors" class="h-3" /> Crop
                        </tw-button>
                        <tw-button variant="light" size="sm" icon="trash" @click="PhotoUploaded = null" />
                      </div>
                    </div>
                  </div>
                  <image-crop-modal v-if="canBeCropped" ref="imageCropModal" :upload="PhotoUploaded" @cropped="cropped" />
                </div>
              </div> -->
              <div v-if="customFieldsRequired && customFieldsRequired.length > 0">
                <tw-input v-for="(customField, index) in customFieldsRequired" :key="'custom-field-key-' + index" v-model="CustomFields[customField.name]" :label="customField.name" />
              </div>
            </div>
            <div v-if="loggedInUser">
              <tw-button size="lg" :loading="LoadingJoiningCause" variant="amber" class="w-full" @click="joinCause">
                Create Fundraising Page
              </tw-button>
            </div>
            <tw-modal ref="userRegisterAccountModal" no-footer>
              <register-user-account ref="registerUserAccount" no-redirect @cancel-registration="$refs.userRegisterAccountModal.close()" @user-registered="userRegistered" />
            </tw-modal>
            <tw-modal ref="userLoginModal" no-footer>
              <login-form no-redirect @user-logged-in="userLoggedIn" />
            </tw-modal>
          </tw-card>
        </div>
        <tw-loading-spinner v-else />
      </tw-transition-container>
    </div>
  </tw-container-full-width>
</template>

<style scoped>

</style>
